import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	application: null,
	event: null,
	loading: false,
	loadingSubmit: false
};

export default function applicationInfoPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_EVENT_REQUEST:
		case ActionTypes.GET_EVENT_ERROR:
		case ActionTypes.GET_EVENT_SUCCESS:
		case ActionTypes.SUBMIT_START_APPLICATION_REQUEST:
		case ActionTypes.SUBMIT_START_APPLICATION_ERROR:
		case ActionTypes.SUBMIT_START_APPLICATION_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_START_APPLICATION_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_START_APPLICATION_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
